import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { InstitutionProgramsGQL } from '@cpd-app/generated';

import {
  InstitutionProgram,
  ProgramsForInstitutionOptions
} from '../../models';
import {
  cipCodeCutoffFilterMapper,
  edLevelToEdLevelFilterMapper
} from '../../mappers';

@Injectable({
  providedIn: 'root'
})
export class InstitutionProgramDataService {
  constructor(private institutionProgramsGQL: InstitutionProgramsGQL) {}

  public getInstitutionPrograms(
    institutionId: string,
    onetCode: string,
    options: ProgramsForInstitutionOptions
  ): Observable<InstitutionProgram[]> {
    return this.institutionProgramsGQL
      .fetch({
        schoolId: +institutionId,
        onetCode: onetCode,
        educationLevel: edLevelToEdLevelFilterMapper(+options.edLevelId),
        cipCodeCutoff: cipCodeCutoffFilterMapper(options.cipCodeCutoff),
        medianEarnings: options.medianEarnings
      })
      .pipe(
        map((results) => {
          const searchTerm = options?.searchTerm?.toLowerCase();

          if (searchTerm) {
            return results?.data?.institutionPrograms.filter((item) => {
              return item.programName?.toLowerCase().includes(searchTerm);
            });
          }

          return results?.data?.institutionPrograms;
        })
      );
  }
}
